// extracted by mini-css-extract-plugin
export default {"landingPage":"style_landingPage__pZ11l","container":"style_container__jpTF9","bgImage":"style_bgImage__90Edq","text":"style_text__BeQzl"};